/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Required_DescInputs */

const en_dialog_premium_required_desc = /** @type {(inputs: Dialog_Premium_Required_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To continue using Listening, please update your subscription`)
};

const es_dialog_premium_required_desc = /** @type {(inputs: Dialog_Premium_Required_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para continuar usando Listening, actualiza tu suscripción`)
};

/**
* | output |
* | --- |
* | "To continue using Listening, please update your subscription" |
*
* @param {Dialog_Premium_Required_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_required_desc = /** @type {((inputs?: Dialog_Premium_Required_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Required_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_required_desc(inputs)
	return en_dialog_premium_required_desc(inputs)
});